const pushAnalyticsDataEvent = (data) => {
  if (typeof window !== "undefined") {
    window.digitalDataEvents = window.digitalDataEvents || [];
    window.digitalDataEvents.push(data);
  }
};
export {
  pushAnalyticsDataEvent
};
